import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.back.label",
    defaultMessage: "Back",
    description: "Back button label",
  },
});
